import { render, staticRenderFns } from "./details2.vue?vue&type=template&id=9da5d6a0"
import script from "./details2.vue?vue&type=script&lang=js"
export * from "./details2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports